<template>
  <div
    :class="
      isShowDetail ? 'business-open-content' : 'business-open-content approval'
    "
  >
    <shop-detail-info @crumbsBack="crumbsBack" v-if="isShowDetail" />
    <div class="approval-content" v-else>
      <span class="title">
        {{ titleText[$route.params.shopType] }}
      </span>
      <div class="approval-record">
        <!--您的店铺目前审批状态为（{{ recordArr.length && recordArr[recordArr.length - 1].operResultName }}）-->
        <template v-if="shopType">
          <div>
            <div style="width: 81px; display: inline-block; overflow: hidden">
              退回原因：
            </div>
            <div
              class="returnInfo"
              :title="resultInfo.result ? resultInfo.result : '退回'"
              style="display: inline-block"
            >
              {{ resultInfo.result ? resultInfo.result : "退回" }}
            </div>
          </div>
        </template>
        <template v-else>
          <div>您的店铺目前审批状态为<span>审批中</span></div>
        </template>
        <el-button
          v-if="!shopType"
          plain
          type="single-number"
          style="float: right"
          @click="toDetail"
          >查看详情</el-button
        >
      </div>
      <div class="bottom-wrapper" v-if="shopType">
        <div class="data-bottom-btn" @click="goEditInfoPage">去修改</div>
        <div class="data-bottom-btn" @click="goHomePage">去首页</div>
      </div>
      <div class="data-bottom-btn" @click="goHomePage" v-else>去首页</div>
      <!--<span class="see" @click="seeClick">查看我的其它公司或注册新公司</span>-->
    </div>
  </div>
</template>

<script>
import { getQryRecord } from "@/api/approval-view";
import shopDetailInfo from "../shop-detail-info/shop-detail-info.vue";
const empurl = process.env.VUE_APP_EMP_URL;

export default {
  name: "approval-view",
  components: {
    shopDetailInfo,
  },
  data() {
    return {
      empurl,
      recordArr: [],
      titleText: {
        2: "审批记录",
        4: "审批退回",
      },
      isShowDetail: false,
    };
  },
  computed: {
    reload() {
      return this.$store.state.app.reload;
    },
    shopType() {
      return this.decryptShopType === "4";
    },
    resultInfo() {
      return this.$store.state.app.resultInfo;
    },
    decryptShopId() {
      return this.$crypto.Decrypt(this.$route.params.shopId);
    },
    decryptShopType() {
      return this.$crypto.Decrypt(this.$route.params.shopType);
    },
  },
  mounted() {
    console.log(this.$route, "路由对象");
    this.mountedFn();
  },
  beforeRouteLeave(to, from, next) {
    console.log(this.deleteLoad, this, "双方都");
    this.deleteLoad();
    next();
  },
  methods: {
    crumbsBack() {
      this.isShowDetail = false;
    },
    toDetail() {
      this.isShowDetail = true;
    },
    seeClick() {
      this.$store.dispatch("businessOpenShopSetStep", 2);
      this.$router.replace("/business-open-shop/register");
    },
    deleteLoad() {
      window.removeEventListener("beforeunload", (e) => this.onbeforeunload(e));
      //window.onbeforeunload = null
    },
    onbeforeunload(e) {
      e = e || window.event;
      // 兼容IE8和Firefox 4之前的版本
      if (e) {
        e.returnValue = "关闭提示";
      }
      // this.$router.push('/business-shop/apply-shop/input-business-name')
      // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      return "关闭提示";
    },
    mountedFn() {
      if (this.reload) {
        this.deleteLoad();
        this.$router.replace("/business-open-shop/ready-data");
        this.$store.commit("RELOAD_SET", false);
        return false;
      }
      this.$store.commit("RELOAD_SET", true);
      // window.addEventListener('beforeunload', e => this.onbeforeunload(e))
      window.onbeforeunload = this.onbeforeunload;
      getQryRecord({ shopId: this.decryptShopId, isShowLoading: true }).then(
        (res) => {
          console.log(res, "查询审批记录");
          if (res.data.code === "0") {
            this.recordArr = res.data.data;
          }
        }
      );
    },
    goHomePage() {
      // this.$router.replace('/index')
      window.location.href = this.$addUrlPerFix(this.empurl);
    },
    goEditInfoPage() {
      sessionStorage.setItem("businessName", this.resultInfo.businessName);
      this.$router.replace("/business-open-shop/input-business-info");
      this.$store.dispatch("businessOpenShopSetStep", 3);
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .business-open-content {
}
.approval {
  display: flex;
  justify-content: center;
  height: calc(100vh - 285px) !important;
  padding-top: 40px;
  .returnInfo {
    width: 340px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .see {
    color: #ff142f;
    display: block;
    cursor: pointer;
    margin-top: 10px;
    font-size: 13px;
    user-select: none;
  }
  .approval-content {
    width: 500px;
    .approval-record {
      margin-bottom: 60px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      span {
        color: #ff142f;
      }
    }
  }
  .title {
    width: 100%;
    font-size: 20px;
    color: #4a4a4a;
    line-height: 28px;
    display: block;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .bottom-wrapper {
    display: flex;
    justify-content: space-between;
    .data-bottom-btn {
      width: 48% !important;
    }
  }
}
/deep/ .el-button {
  background: #ffffff;
  border-color: #ff142f;
  span {
    color: #ff142f;
  }
  &:hover,
  &:active {
    border-color: #ff142f !important;
    background-color: #ffedef !important;
  }
  &:focus {
    border-color: #ff142f !important;
  }
}
</style>
